<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100 md-xsmall-size-100">
      <h4 class="card-title">Logo Imagen</h4>
      <div class="file-input">
        <!-- No Tiene Logo desde backend -->
        <div v-if="!imageFile">
          <div class="image-container">
            <img :src="imageDefault" />
          </div>
        </div>
        <!-- tiene Imagen desde Backend-->
        <div v-else class="image-container">
          <!-- from file -->
          <img v-if="toShow" :src="toShow" title />
          <!-- from backend -->
          <img v-else-if="imageFile" :src="imageFile" title name="image" />
        </div>
        <div class="button-container">
          <!-- Solo si Existe una Imagen -->
          <md-button class="md-danger md-round" @click="removeImage" v-show="imageFile">
            <md-icon>close</md-icon>Quitar
          </md-button>

          <md-button class="md-success md-round md-fileinput">
            <!-- No hay Imagen -->
            <template v-if="!imageFile">Cargar imagen</template>
            <!-- Si hay Imagen -->
            <template v-else>Cambiar</template>
            <input type="file" @change="onFileChange" />
          </md-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import reduceImageQuality from "../../utils/reduceImageQuality";
export default {
  name: "ImageField",

  props: {
    editedObject: Object,
    fieldName: {
      type: String,
      default: "logo",
    },
    useBase64: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      toShow: "",
      imageDefault: require("@/assets/images/default-avatar.png"),
      imageFile: null,
    };
  },

  computed: {
    objectImage: {
      get() {
        return this.editedObject[this.fieldName];
      },
      set(value) {
        this.editedObject[this.fieldName] = value;
      },
    },
  },

  watch: {
    // How to make a dynamic watcher to watch for new changes for ${fieldName} prop.
    "editedObject.image": function (v) {
      this.imageFile = !!v && v;
    },
  },

  mounted() {
    const img = this.objectImage;
    if (img) {
      this.imageFile = img;
    }
  },

  methods: {
    onFileChange(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return; //Multiples Images selected

      const file = files[0];

      this.imageFile = file;

      if (!this.useBase64) {
        this.objectImage = file;
      }

      this.createImage(file);
    },

    createImage(file) {
      let reader = new FileReader();
      reader.onload = (e) => {
        const result = e.target.result;
        this.toShow = result;
        if (this.useBase64) {
          setTimeout(() => {
            reduceImageQuality(result).then((file) => {
              this.objectImage = file;
            });
          }, 100);
        }
      };
      reader.readAsDataURL(file); // puede retornar imagen de url
    },

    removeImage() {
      this.objectImage = null;
      this.imageFile = null;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Inputs/ImageField.vue